  $(document).ready(function(){ 
    
      setTimeout(function(){
        $(".spr-badge").addClass('ratting');
        },2000);
//     setTimeout(function(){ 
//        $('.recommended-slide').slick({
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 2000,
//       });
//    },9000);
    
    // Increase Iframe width and height for blogs js
    $(".video-block iframe").width(600);
    $(".video-block iframe").height(380);

    // Increase Iframe width and height on single view article js
    $(".video-article-temp iframe").width(750);
    $(".video-article-temp iframe").height(600);

    // Increase Iframe width and height on single view article for recent post js
    $(".recent-article-content iframe").width(150);
    $(".recent-article-content iframe").height(150);
    
     var uploadimage = setInterval(function(){   
     if($('.single-article-title').length){

         $(".single-article-title").appendTo(".content-wrapper.collections, .content-wrapper.blogs");      
     clearInterval(uploadimage);
        }
    }, 100);

/*********************************/    
  //  Tabs on product page jquery

    $('#tabs-nav li:first-child').addClass('active');
      $('.tab-content').hide();
      $('.tab-content:first').show();

      // Click function
      $('#tabs-nav li').click(function(){
        $('#tabs-nav li').removeClass('active');
        $(this).addClass('active');
        $('.tab-content').hide();

        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
    });

/************************************************/
  //home blog slider js in mobile
if (window.matchMedia('(max-width: 767px)').matches) {
   $('.custom-home-blog').slick({
      infinite: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
}

/************************************************/
    
  $('.promo-section-header').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
        });   

/************************************************/

// $('.custom-collection-list').slick({
//    slidesToShow: 1,
//    slidesToScroll: 1,
//    autoplay: true,
//    autoplaySpeed: 2000,
//  }); 
    
//   $('.custom-collection-list').slick({
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   autoplay: false,
//   autoplaySpeed: 2000,
//   prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
//   nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
//       responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: true,
//         centerMode: false,
//         centerPadding: '40px',
//         slidesToShow: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: true,
//         centerMode: false,
//         centerPadding: '40px',
//         slidesToShow: 1
//       }
//     }
//   ]
// });

$('.custom-collection-list2').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  infinite: false,
  prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
  nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

    /*****************************************/
  
// jQuery for custom-product-cart section
$(document).ready(function(){   
  $('.collection-submit-btn').click(function(e){
    e.preventDefault();
    var quantity = $(this).parent().children('div.wrap').find('[name="quantity"]').val();
    // console.log(quantity);
    var product_id = $(this).parent().parent().find('[name="id"]').val();
    $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        data: {quantity: quantity, id: product_id},
      
        success: function(response) {
          // console.log(response);
           $.getJSON('/cart.js', function(cart) {
              if($(".cart-count-bubble").length < 1){
                 $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span aria-hidden="true">1</span><span class="visually-hidden">1 items</span></div>');
               }
               $('.cart-count-bubble').html(cart.item_count);
            
              swal({
                     text: "Product Added Successfully!",
                     type: "success",
                     timer: 2000,
                      buttons: false,
                      icon: "success"
                     });
             
            });
            
        },
        error: function(error) {
            console.log(error);
        }
    });
  });
  
}); 

    /***********************************************/
    
  $('.banner-slider-section').slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed:3000,
    speed: 2000,
    slidesToShow: 1,
    adaptiveHeight: true,
    prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'
  });

/***************************************/
  $('.custom-collection-slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
  nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});
    
    /**************************************************/

  $(document).ready(function(){
    $('.index-video-play-icon').click(function(){
    $('.video-placeholder-img').hide();
    $('.video_section_slide').show();
      $('#index-video').trigger('play'); 
    });
  
   $('.video_section_slide').click(function(){
     $('#index-video').trigger('pause');
     $(this).hide();
     $('.video-placeholder-img').show();
    });

  });

    /************************************/
  
  $(document).ready(function(){
    $('.index-video-play-icon-right').click(function(){
    $('.video-placeholder-img-right').hide();
    $('.video_section_slide-right').show();
      $('#index-video-right').trigger('play'); 
    });
  
   $('.video_section_slide-right').click(function(){
     $('#index-video-right').trigger('pause');
     $(this).hide();
     $('.video-placeholder-img-right').show();
    });

  });


/**********************About page video js****************************/

  $(document).ready(function(){
    $('.aboutPlay-icon').click(function(){
    $('.about-placeholder-img').hide();
    $('.about-section-slider').show();
      $('#index-video_about').trigger('play'); 
    });
  
   $('.about-section-slider').click(function(){
     $('#index-video_about').trigger('pause');
     $(this).hide();
     $('.about-placeholder-img').show();
    });

  });

    
/***********************************************/
      
  $('.product-slider-box.slider').slick({
      vertical: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      prevArrow: '<div class="slick-prev"></div>',
      nextArrow: '<div class="slick-next"></div>',
      dots: false,
      customPaging : function(slider, i) {
      return '<a href="#"><img src="images/slide-dot.png" /><img src="images/slide-dot-active.png" /></a>';
      },
  });


/*******************Product mobile thumbnail slider***********/
 if($(window).width() < 900){   
 $('.mobile-product-thumb').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1
  });
}
/*************************************************************/
    
    $('.customs-testimonials').slick({
        centerMode: true,
        //centerPadding: '60px',
        slidesToShow: 3,
          responsive: [
          {
            breakpoint: 1025,
            settings: {
              arrows: true,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 3
            }
          },  
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 3
            }
          },
          {
            breakpoint: 667,
            settings: {
              dots: false,
              centerMode: true,
              centerPadding: '10px',
              slidesToShow: 1
            }
          }
        ]
      });

    
     var findFlexSlider = setInterval(function(){   
       if($('#omnisend-embedded-v2-64ee0624e726bd61ddff2444').length){
              
           $("#omnisend-embedded-v2-64ee0624e726bd61ddff2444").appendTo(".newsletter-sec");      
       clearInterval(findFlexSlider);
          }
        
      }, 100);
    
      
 });


$(document).on('click', '.submitUpsell', function() {
  var variantId = $(this).parents('.product-item').attr('varinat-id');
  var quantity = 1;

     $.ajax({
             type: 'POST',
             url: '/cart/add.js',
             data: {
                  quantity: 1,
                  id: variantId
               },
                dataType: 'json', 
                  success: function(response) {
                    $('.messages').html('<p class="success-message">Sample Product added to cart successfully!</p><a class="button comman-btn" href="/cart/">View Cart</a>');
                    setTimeout(function() {
                      $('.message').empty();
                    }, 10000);
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    $('.messages').html('<p class="error-message">Failed to add product to cart. Please try again.</p>');
                    setTimeout(function() {
                      $('.messages').empty();
                    }, 10000);
                  }
           });
  
});
 

   jQuery(function($) {
      $('a[href*="#"]:not([href="#"])').click(function() {
          var target = $(this.hash);
            $('html,body').stop().animate({
              scrollTop: target.offset().top - 150
            }, 'linear');   
      });    
        if (location.hash){
        var id = $(location.hash);
        }
        $(window).on('load', function() {
        if (location.hash){
            $('html,body').animate({scrollTop: id.offset().top -150}, 'linear')
        };
        });
    });


// code for mega menu 
// $('ul.list-menu.list-menu--inline li details').hover(
//     function () {
//         // On hover (mouseenter)
//         $(this).attr('open', true)
//             .find('summary')
//             .attr('aria-expanded', 'true');

//         // Open the details with animation
//         $(this).find('summary + *').stop(true, true).slideDown(1000); // Adjust animation duration as needed
//     },
//     function () {
//         // On hover out (mouseleave)
//         $(this).attr('open', false)
//             .find('summary')
//             .attr('aria-expanded', 'false');

//         // Close the details with animation
//         $(this).find('summary + *').stop(true, true).slideUp(1000); // Adjust animation duration as needed
//     }
// );

// code for mega menu



